// extracted by mini-css-extract-plugin
export default {"root":"Contacts_root__7zVIa","mail":"Contacts_mail__xkiWX","addressContainer":"Contacts_addressContainer__X9wKF","address":"Contacts_address__yXnex"};